import { render, staticRenderFns } from "./dialogConfirmDelete.vue?vue&type=template&id=1247619c&"
import script from "./dialogConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./dialogConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./dialogConfirmDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports